import React, { useContext } from "react";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStickyNote } from "@fortawesome/free-regular-svg-icons";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";

import { NotesContext } from "../contexts/index";

const NoteIcon = ({ showNotes, toggleNotes }) => {
    const { notes } = useContext(NotesContext);

    const icon = notes.length > 0 ? faStickyNote : faPencilAlt;

    return (
        <button
            className={classnames("button", { "-pressed": showNotes })}
            title="Notes"
            onClick={() => {
                toggleNotes();
            }}
        >
            <FontAwesomeIcon icon={icon} />
        </button>
    );
};

export default NoteIcon;
